/**
 * Institution Statistics Component
 */

import React from 'react';
import { Grid, Column } from '@carbon/react';
import { Growth, ChevronDown } from '@carbon/icons-react';
import type { Statistic } from '../../../../shared/interfaces/InstitutionalLanding';

interface InstitutionStatisticsProps {
  statistics: Statistic[];
}

const InstitutionStatistics: React.FC<InstitutionStatisticsProps> = ({ statistics }) => {
  return (
    <section className="institution-statistics">
      <Grid narrow>
        {statistics.map((stat, index) => (
          <Column key={index} lg={4} md={4} sm={4}>
            <div className="stat-card">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
              {stat.description && <div className="stat-description">{stat.description}</div>}
              {stat.trend && (
                <div className={`stat-trend trend-${stat.trend}`}>
                  {stat.trend === 'up' && <Growth size={16} />}
                  {stat.trend === 'down' && <ChevronDown size={16} />}
                  {stat.trendValue && <span>{stat.trendValue}</span>}
                </div>
              )}
            </div>
          </Column>
        ))}
      </Grid>
      <style>{`
        .institution-statistics {
          padding: 3rem 0;
          background: linear-gradient(135deg, var(--cds-interactive-01) 0%, var(--cds-interactive-02) 100%);
        }
        .stat-card {
          text-align: center;
          padding: 2rem 1rem;
          color: white;
        }
        .stat-value {
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
        }
        .stat-label {
          font-size: 1.125rem;
          margin-bottom: 0.5rem;
        }
        .stat-description {
          font-size: 0.875rem;
          opacity: 0.9;
        }
        .stat-trend {
          display: inline-flex;
          align-items: center;
          gap: 0.25rem;
          margin-top: 0.5rem;
          font-size: 0.875rem;
        }
        .trend-up { color: #24a148; }
        .trend-down { color: #da1e28; }
      `}</style>
    </section>
  );
};

export default InstitutionStatistics;
